import header from "./laptop-mit-exposes.webp";
import section1 from "./expose-objektbeschreibung-immobilienvermittlung.png";
import section2 from "./beispiel-expose.webp";
import section3 from "./beispiel-expose-flyer.webp";
import section4 from "./beratungsgespraech-immobilienmakler.webp";
import section5 from "./immobilienanzeige-immoMates.png";
import section6 from "./expose.png";
import section7 from "./wiese-mit-landmarken.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
